import { render } from "./InviiDaModificareComponent.vue?vue&type=template&id=d8da5f5a&scoped=true"
import script from "./InviiDaModificareComponent.vue?vue&type=script&lang=js"
export * from "./InviiDaModificareComponent.vue?vue&type=script&lang=js"

import "./InviiDaModificareComponent.vue?vue&type=style&index=0&id=d8da5f5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8da5f5a"]])

export default __exports__